import { ReactNode, MouseEvent } from "react";
import { ButtonType } from "@sebgroup/extract";
import Spinner from "../Loaders/Spinner";

interface IconButtonProps {
  children: ReactNode;
  type?: ButtonType;
  onClick: ((event: MouseEvent) => void) | (() => void);
  "aria-expanded"?: boolean;
  "aria-controls"?: string;
  "aria-label"?: string;
  size?: "small" | "normal";
  "data-testid"?: string;
  loading?: boolean;
}

const IconButton = (props: IconButtonProps) => {
  const handleClick = (event: MouseEvent) => {
    if (!props.loading) {
      props.onClick(event);
    }
  };

  return (
    <button
      className={`icon ${props.size === "small" && "small"}`}
      onClick={handleClick}
      aria-controls={props["aria-controls"]}
      aria-expanded={props["aria-expanded"]}
      type={props.type ?? "button"}
      data-testid={props["data-testid"]}
      aria-label={props["aria-label"]}
      aria-busy={props.loading}
    >
      {props.loading ? <Spinner color="inherit" /> : props.children}
    </button>
  );
};

export default IconButton;
